import { FC } from "react";
import { FieldValues, UseFormRegister } from "react-hook-form";

import { Field } from "@types";

import { Label } from "./Label";
import s from "./CheckboxField.module.scss";

interface Props extends Field {
  register: UseFormRegister<FieldValues>;
}

export const SingleCheckboxField: FC<Props> = ({ label, name, register, required }) => (
  <div className={s.SingleCheckbox}>
    <input id={name} type="checkbox" {...register(name)} required={required} />
    <Label id={name} label={label} required={required} />
  </div>
);
